webpackJsonp([142792665573897],{

/***/ 439:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>The odds are higher that you’ll get hepatitis C if you:</p>\n<p>Had a blood transfusion before 1990. A screening test for HCV went into use that year. Before then, this was the main cause of most new cases in the U.S.</p>\n<p>Use needles to take illegal drugs. This is one of the most common ways to get hep C. Up to 80% of new users get the disease within 6 to 12 months.</p>\n<p>Snort cocaine. People who share straws or other tools to inhale this drug raise their risk.</p>\n<p><a href=\"https://www.webmd.com/hepatitis/risk-hepatitis-c#1\">via WebMD</a></p>","frontmatter":{"path":"webmd-risk","title":"Who is at risk? (WebMD)","date":"2018-05-11","tags":["transfusion","illegal drugs","snort"]}}},"pathContext":{"slug":"webmd-risk"}}

/***/ })

});


// WEBPACK FOOTER //
// path---article-webmd-risk-b3b2a934b3d968b20cbb.js